import React, { useState} from "react";
import {notifyError, notifySuccess, } from "../../utils/helpers";
import {
    BUTTON,
    INTEGRATION_TYPES
} from "../../utils/constants";
import {Modal} from "react-bootstrap";
import YuJaButton from "../standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";

import {YuJaTextBox} from "../standardization/YuJaTextBox";
import classes from "../../pages/CreateQuizPage/ActivityEditor.module.css";
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import { useTranslation } from "react-i18next";


export default function CreateD2LModuleModal({setModalShow, show, selectedCourseId, saveSuccessCb}) {
    const { t } = useTranslation();
    const {createD2LModule, createMoodleSection} = LTIApiCalls();
    const {getIntegrationType} = useSynLMSConfiguration();

    const [newName, setNewName] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    let integrationType = getIntegrationType();

    const handleClose = () =>{
        resetStatus();
        setModalShow(false);
    };

    const resetStatus = () => {
        setNewName("");
    }


    const handleSave = () => {
        if (!newName) {
            notifyError(integrationType === INTEGRATION_TYPES.D2L
                ? "Module name can not be empty."
                : "Section name can not be empty."
            );
            return;
        }

        setIsSaving(true);
        if (integrationType === INTEGRATION_TYPES.D2L) {
            createD2LModule(selectedCourseId, newName).then((success) => {
                if (success) {
                    notifySuccess(t("institution.saveD2lModuleSuccess", { moduleName: newName }));
                    saveSuccessCb();
                }

                setModalShow(false);

            }).finally(() => setIsSaving(false));
        } else {
            createMoodleSection(selectedCourseId, newName).then((success) => {
                if (success) {
                    notifySuccess(t("institution.saveD2lModuleSuccess", { moduleName: newName }));
                    saveSuccessCb();
                }

                setModalShow(false);

            }).finally(() => setIsSaving(false));
        }


    }

    return (
        <Modal
            id="form-modal"
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName= {"save-question-bank-modal"}
        >

            <ModalClose
                tabIndex={0}
                role={BUTTON}
                aria-label={t("common.close")}
                onClick={handleClose}
                className="modal-close"
                style={{width: "24px", height: "24px"}}
            />
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title className="modal-title" >
                    {t("common.create")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{display: "flex", flexDirection: "column", gap: 25, minHeight: 100}}>
                <span style={{color: "#6B6B6B", fontSize: 15, fontWeight: "400"}}>
                    {integrationType === INTEGRATION_TYPES.D2L
                        ? t("questionBuilder.createModuleDesc")
                        : t("questionBuilder.createSectionDesc")
                    }
                </span>
                <YuJaTextBox
                    value={newName}
                    containerStyle={{width: 250, height: 40, fontSize: 15}}
                    onChange={e => setNewName(e.target.value)}
                    placeholder={integrationType === INTEGRATION_TYPES.D2L  ? t("questionBuilder.enterModuleName") : t("questionBuilder.enterSectionName")}
                />
            </Modal.Body>
            <Modal.Footer>
                <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                    <span style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                        <YuJaButton
                            onClick={handleClose}
                            type={"secondary"}
                            style={{width: 120, height: 35, display: "flex", alignItems: "center", justifyContent: "center"}}
                        >
                           {t("common.cancel")}
                        </YuJaButton>

                        <YuJaButton
                            onClick={handleSave}
                            disabled={!newName}
                            style={{width: 120, height: 35, display: "flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap"}}
                        >
                           {isSaving
                               ? <span className={classes.savingText}>{t("questionBuilder.savingText")}</span>
                               : (integrationType === INTEGRATION_TYPES.D2L ? t("integration.createModule") : t("integration.createSection"))
                           }
                        </YuJaButton>
                    </span>
                </div>
            </Modal.Footer>

        </Modal>
    );
}